import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["area"]
  height = 0;

  connect() {
    this.height = this.areaTarget.scrollHeight
    this.areaTarget.classList.add("is-collapsed")
  }

  clicked(event) {
    event.preventDefault()
    this.areaTarget.classList.toggle("is-collapsed")

    if(this.areaTarget.classList.contains("is-collapsed")) {
      this.areaTarget.style = `max-height: 0px; transition: max-height 0.5s ease-in-out;`
    } else {
      this.areaTarget.style = `max-height: ${this.height}px; transition: max-height 0.5s ease-in-out;`
    }
  }
}